import React from "react";

const NewUserScreen = () => <div>why</div>;

export default NewUserScreen;
